import { formatDate } from "@/Utils";

export interface Company {
  id: number;
  name: string;
  cnpj: string | null;
  email: string | null;
  phone: string | null;
  active: boolean;
  createdAt?: string | null;
}

export interface CompanyMember {
  id: number;
  name: string;
  email: string;
}

export interface CompanyOption {
  id: number;
  name: string;
}

export interface CompanyFormData {
  name: string;
  cnpj: string;
  email: string;
  phone: string;
  active: boolean;
}

export interface CompanyStatusOption {
  value: boolean;
  label: string;
}

export interface TableFlag {
  name: string;
  color: string;
}

export type CompanyTableRow = Array<string | number>;

export const toCompanyOption = (company: Company): CompanyOption => ({
  id: company.id,
  name: company.name,
});

export const toCompanyFormData = (company: Company): CompanyFormData => ({
  name: company.name ?? "",
  cnpj: company.cnpj ?? "",
  email: company.email ?? "",
  phone: company.phone ?? "",
  active: company.active,
});

export const toCompanyTableRow = (company: Company): CompanyTableRow => [
  company.id,
  company.name,
  company.cnpj ?? "-",
  company.email ?? "-",
  company.phone ?? "-",
  company.createdAt ? formatDate(company.createdAt) : "-",
];

export const toCompanyStatusFlag = (company: Company): TableFlag =>
  company.active
    ? { name: "Ativo", color: "active" }
    : { name: "Inativo", color: "inactive" };
